/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillSavingsCashInActivityRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {BackfillSavingsCashInActivityResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const backfillSavingsCashInActivity = (request: BackfillSavingsCashInActivityRequest, options?: CashRequestOptions) => post<BackfillSavingsCashInActivityRequest, BackfillSavingsCashInActivityResponse>("/2.0/cash/backfill-savings-cash-in-activity", request, {...options, rejectOnError: true })